import axiosClient from "./axiosClient";

const staffApi = {
    createStaff: async (data: any) => {
        const res = await axiosClient.post("/staff", data);
        return res;
    },
    updateProfileStaff: (id: number, data: FormData ) => {
        return axiosClient.patch(`/staff/${id}`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
};

export default staffApi;
